import * as React from 'react';
import { IOrgAssetGraphItem } from '../../../../interfaces/OrgAssets/IOrgAssetGraphItem';
import { Helper } from '../../../../Helper';
import { Environment } from '../../../../services/Environment';
import { IEnvironment } from '../../../../interfaces/IEnvironment';
import ReactPlayer from 'react-player';
import * as styles from './OrgAssetFile.css';
import { IASkeleton } from '../../../skeleton/Skeleton';


export interface IAOrgAssetFileProps {
  file: IOrgAssetGraphItem;
  environment: IEnvironment;
  tenant: string;
  token: string;
  onClick: () => void;
}

export interface IAOrgAssetFileState {
  isLoading: boolean;
  hasError: boolean;
}

export class IAOrgAssetFile extends React.Component<IAOrgAssetFileProps, IAOrgAssetFileState> {
  constructor(props: IAOrgAssetFileProps) {
    super(props);
    this.state = {
      isLoading: true,
      hasError: false
    };
  }

  public render(): JSX.Element {
    const isImage = this.props.file.mimeType?.includes("image");
    const height = 200;
    return (
      <div
        className={styles.IA_OrgAssetFileContainer}
        style={{
          display: this.state.hasError ? "none" : undefined
        }}
        onClick={() => this.props.onClick()}
      >
        {isImage
        ? 
          <img
            style={{
              opacity: this.state.isLoading ? 0 : 1,
              position: this.state.isLoading ? "absolute" : undefined,
              height: height
            }}
            src={Helper.getImageFromApiWhenOutsideSharepoint(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.props.file.webUrl, "", "Full", undefined, undefined, true)}
            onLoad={() => this.setState({isLoading: false})}
            onError={() => this.setState({hasError: true})}
          />
        :
          <ReactPlayer
            style={{
              opacity: this.state.isLoading ? 0 : 1,
              position: this.state.isLoading ? "absolute" : undefined
            }}
            height={height}
            width="auto"
            url={Helper.getVideoUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.props.file.webUrl)}
            pip={false}
            onReady={() => this.setState({isLoading: false})}
            onError={() => this.setState({hasError: true})}
          />
        }
        {this.state.isLoading
        ?
          <IASkeleton
            skeleton={{
              width: !isImage ? 355 : 200,
              height: height,
              borderRadius: 5
            }}
          />
        :
          <div className={styles.IA_OrgAssetFileTextOverlay}>
            {this.props.file.name}
          </div>
        }
      </div>
    );
  }
}
